<ng-container *ngIf="!_progress && !_success">{{standardButtonLabel | translate}}</ng-container>
<ng-container *ngIf="_progress">
    <mat-progress-spinner
            class="absolute-spinner"
            [color]="'accent'"
            [mode]="'indeterminate'"
            [diameter]="40"
            [strokeWidth]="3" *ngIf="!_success">
    </mat-progress-spinner>
</ng-container>
<ng-container *ngIf="_success">{{successButtonLabel | translate}}</ng-container>
